import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onLogin } from "../../controller/LoginController";
import Alert from "react-bootstrap/Alert";
import AuthUtility from "../../util/AuthUtility";
import { Col, Row, Container} from 'react-bootstrap';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (AuthUtility.isUserLoggedIn()) {
      navigate("/home");
      window.location.reload();
    }
  }, [])

  const [{username, password, grant_type}, setCredentials] = useState({
    username: '',
    password: '',
    grant_type: 'password'
  })

  const [error, setError] = useState('');

  const login = async (event: React.FormEvent) => {
    event.preventDefault();
    const response = await onLogin({
      username,
      password,
      grant_type
    })

    if (response && response.error) {
      if (response.error.status === 401) {
        setError("Нууц үг буруу байна")
      } else {
        setError("Нэвтрэх нэр эсвэл нууц үг буруу байна");
      }
    } else {
      AuthUtility.saveUserCredential({
        accessToken: response.access_token,
        refreshToken: response.refresh_token
      });
      navigate("/home");
      window.location.reload();
    }
  }

  return (
    <section style={{ padding: "7em 0" }}>
        <Container>
          <Row className="d-flex justify-content-center align-items-center mb-3" style={{ background: "#fff" }}>
            <Col md={12} lg={12} xs={12}>
                  <div className="d-md-flex">
                      <img src="/images/rain-opacity.png"  style={{ height: '100%', padding: '30px' }} />
                      <div className="p-4 p-md-5">
                          <div className="d-flex">
                              <div className="w-100">
                                  <h3 className="mb-4">Нэвтрэх</h3>
                              </div>
                          </div>
                          <form name="loginForm" className="signin-form" onSubmit={login}>
                              <div className="form-group mb-3">
                                {
                                  error && (
                                    <Alert variant="danger" style={{ width: "100%" }}>
                                      <Alert.Heading style={{fontSize: "1.2em"}}>
                                        {error}
                                      </Alert.Heading>
                                    </Alert>
                                  )
                                }
                              </div>
                              <div className="form-group mb-3">
                                  <label className="label">Нэр</label>
                                  <input type="text"
                                    className="form-control"
                                    placeholder="Нэр"
                                    value={username}
                                    onChange={(event) => setCredentials({
                                      username: event.target.value,
                                      password,
                                      grant_type
                                    })}/>
                              </div>
                              <div className="form-group mb-3">
                                  <label className="label">Нууц үг</label>
                                  <input type="password"
                                  className="form-control"
                                  placeholder="Нууц үг"
                                  value={password}
                                  onChange={(event) => setCredentials({
                                    username,
                                    password: event.target.value,
                                    grant_type
                                  })}/>
                              </div>
                              <div className="form-group">
                                  <button type="submit"
                                  className="form-control btn btn-primary rounded submit px-3">Нэвтрэх</button>
                              </div>
                          </form>
                      </div>
                  </div>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default Login;
